import React from "react";
import { Pagination as MuiPagination } from "@mui/material";
import "./Pagination.scss";

/**
 * @param {number} count - Número total de páginas
 * @param {number} page - Número de página actual
 * @param {function} onChange - Función callback cuando cambia la página
 * @param {string} className - Clases CSS adicionales
 * @param {object} props - Props adicionales pasados al componente MUI Pagination
 */
export const Pagination = ({
  count = 1,
  page = 1,
  onChange,
  className = "",
  ...props
}) => {
  return (
    <MuiPagination
      count={count}
      page={page}
      onChange={onChange}
      variant="outlined"
      shape="rounded"
      size="medium"
      className={`pagination-custom ${className}`}
      {...props}
    />
  );
};
